export const queryKeys: any = {
  FuelTypesMaster: {
    title: "Fuel types from master",
    key: "fuel-types-master",
    url: () => `fuel_type_master/`,
  },
  VesselTypesMaster: {
    title: "Vessel types from master",
    key: "vessel-types-master",
    url: () => `vessel_type_master/`,
  },
  /* FuelEU Maritime. The factor table is the fuel picker's source; the targets
     endpoint serves the Art. 4(2) reduction ladder so the UI does not carry a
     second copy of a regulatory constant. */
  FuelMultiplyingFactor: {
    title: "FuelEU Annex I/II emission factors",
    key: "fuel-multiplying-factor",
    url: () => `fuel_multiplying_factor/`,
  },
  FuelEUTargets: {
    title: "FuelEU GHG intensity targets by year",
    key: "fueleu-targets",
    url: () => `fueleu-targets/`,
  },
  FuelEUCalculator: {
    title: "FuelEU compliance balance calculations",
    key: "fueleu-calculator",
    url: () => `fueleu_calculator/`,
  },
  /* The day-by-day planning half: the same fuel table and the same Annex I
     maths, entered as a daily burn over a horizon of 1-365 days. */
  FuelEUDailyCalculator: {
    title: "FuelEU day-by-day biofuel requirement plans",
    key: "fueleu-daily-calculator",
    url: () => `fueleu_daily_calculator/`,
  },
};
